import { gql } from 'urql';
import { PRODUCT } from '../client';

export const UPDATE_LOCATIONS_DELIVER_WITHIN_STORE_HOURS = gql`
  mutation ${PRODUCT}UpdateLocationsDeliverWithinStoreHours($input: UpdateLocationsDeliverWithinStoreHoursMutationInput!) {
    updateLocationsDeliverWithinStoreHours(input: $input) {
      updatedLocations {
        id
        scheduledDeliveryTimeSource
        deliverWithinStoreHours
      }
      errors {
        __typename
      }
    }
  }
`;
